$(document).ready(function() {
    $('.carousel-main').flickity({
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
    });

   $('.carousel-nav').flickity({
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        asNavFor: '.carousel-main',
    });
});